import { Typography } from '@mui/material'
import React from 'react'

import { PanelBox } from '../default'
import { PlansTable } from '../tables'

/**
 * @description Renders a component for managing plans.
 *
 * @author Maria Eduarda Franke
 * @returns {React.Component} The rendered component.
 */
const PlansPanel = () => {

    return (
        <PanelBox>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
                Gerenciar Planos
            </Typography>
            <PlansTable />
        </PanelBox>
    )
}

export default PlansPanel